const SvgMap = ({ size = 20, color = 'black' }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={size || '24'}
		height={size || '24'}
		viewBox='0 0 14 20'
		fill='none'>
		<path
			fill-rule='evenodd'
			clip-rule='evenodd'
			d='M3.53162 0.936893C5.71648 -0.332604 8.40203 -0.310415 10.5664 0.995017C12.7095 2.32704 14.012 4.7043 13.9998 7.26157C13.95 9.80206 12.5533 12.1901 10.8075 14.0362C9.79983 15.1065 8.67261 16.053 7.44884 16.8562C7.32281 16.929 7.18475 16.9778 7.04148 17.0001C6.9036 16.9943 6.76932 16.9535 6.65075 16.8816C4.78243 15.6747 3.14334 14.1342 1.81233 12.3341C0.698589 10.8315 0.0658357 9.01613 1.16173e-06 7.13454C-0.00144468 4.57237 1.34677 2.20639 3.53162 0.936893ZM4.79416 8.1949C5.16168 9.10096 6.02918 9.69197 6.9916 9.69197C7.6221 9.6965 8.22819 9.44395 8.67481 8.9906C9.12143 8.53725 9.37148 7.92076 9.36925 7.2785C9.37261 6.29816 8.79546 5.41244 7.90726 5.0349C7.01907 4.65736 5.99504 4.86247 5.31332 5.55447C4.63159 6.24647 4.42664 7.28885 4.79416 8.1949Z'
			fill={color || 'black'}
		/>
		<ellipse opacity='0.4' cx='7' cy='19.0001' rx='5' ry='1' fill={color || 'black'} />
	</svg>
);

export default SvgMap;
<svg xmlns='http://www.w3.org/2000/svg' width='14' height='20' viewBox='0 0 14 20' fill='none'>
	<path
		fill-rule='evenodd'
		clip-rule='evenodd'
		d='M3.53162 0.936893C5.71648 -0.332604 8.40203 -0.310415 10.5664 0.995017C12.7095 2.32704 14.012 4.7043 13.9998 7.26157C13.95 9.80206 12.5533 12.1901 10.8075 14.0362C9.79983 15.1065 8.67261 16.053 7.44884 16.8562C7.32281 16.929 7.18475 16.9778 7.04148 17.0001C6.9036 16.9943 6.76932 16.9535 6.65075 16.8816C4.78243 15.6747 3.14334 14.1342 1.81233 12.3341C0.698589 10.8315 0.0658357 9.01613 1.16173e-06 7.13454C-0.00144468 4.57237 1.34677 2.20639 3.53162 0.936893ZM4.79416 8.1949C5.16168 9.10096 6.02918 9.69197 6.9916 9.69197C7.6221 9.6965 8.22819 9.44395 8.67481 8.9906C9.12143 8.53725 9.37148 7.92076 9.36925 7.2785C9.37261 6.29816 8.79546 5.41244 7.90726 5.0349C7.01907 4.65736 5.99504 4.86247 5.31332 5.55447C4.63159 6.24647 4.42664 7.28885 4.79416 8.1949Z'
		fill='black'
	/>
	<ellipse opacity='0.4' cx='7' cy='19.0001' rx='5' ry='1' fill='black' />
</svg>;
